/**
 * @generated SignedSource<<78b7b9bdc2e2f7ef1ff0740efde863f9>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type colorPickerView_palettesListPaginationQuery$variables = {
  count?: number | null;
  cursor?: string | null;
  paletteTypeID?: number | null;
};
export type colorPickerView_palettesListPaginationQuery$data = {
  readonly " $fragmentSpreads": FragmentRefs<"colorPickerView_palettesListFragment">;
};
export type colorPickerView_palettesListPaginationQuery = {
  response: colorPickerView_palettesListPaginationQuery$data;
  variables: colorPickerView_palettesListPaginationQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": 20,
    "kind": "LocalArgument",
    "name": "count"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "cursor"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "paletteTypeID"
  }
],
v1 = {
  "kind": "Variable",
  "name": "paletteTypeID",
  "variableName": "paletteTypeID"
},
v2 = [
  {
    "kind": "Variable",
    "name": "after",
    "variableName": "cursor"
  },
  {
    "kind": "Variable",
    "name": "first",
    "variableName": "count"
  },
  {
    "kind": "Literal",
    "name": "numberOfColorsToShow",
    "value": 6
  },
  {
    "kind": "Literal",
    "name": "orderBy",
    "value": "DESC"
  },
  (v1/*:: as any*/)
],
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "colorPickerView_palettesListPaginationQuery",
    "selections": [
      {
        "args": [
          {
            "kind": "Variable",
            "name": "count",
            "variableName": "count"
          },
          {
            "kind": "Variable",
            "name": "cursor",
            "variableName": "cursor"
          },
          (v1/*:: as any*/)
        ],
        "kind": "FragmentSpread",
        "name": "colorPickerView_palettesListFragment"
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "colorPickerView_palettesListPaginationQuery",
    "selections": [
      {
        "alias": null,
        "args": (v2/*:: as any*/),
        "concreteType": "PalettesWithColorsConnection",
        "kind": "LinkedField",
        "name": "palettesWithColors",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "PalettesWithColorsEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "Palette",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  (v3/*:: as any*/),
                  (v4/*:: as any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "PaletteColor",
                    "kind": "LinkedField",
                    "name": "colors",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "colorID",
                        "storageKey": null
                      },
                      (v4/*:: as any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "rgbHexCode",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "spotColorName",
                        "storageKey": null
                      },
                      (v3/*:: as any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "__typename",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "cursor",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "PageInfo",
            "kind": "LinkedField",
            "name": "pageInfo",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "endCursor",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "hasNextPage",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": (v2/*:: as any*/),
        "filters": [
          "numberOfColorsToShow",
          "paletteTypeID",
          "orderBy"
        ],
        "handle": "connection",
        "key": "colorPickerView_palettesList_palettesWithColors",
        "kind": "LinkedHandle",
        "name": "palettesWithColors"
      }
    ]
  },
  "params": {
    "cacheID": "a33efbdb52284473efe8bca589ce4f72",
    "id": null,
    "metadata": {},
    "name": "colorPickerView_palettesListPaginationQuery",
    "operationKind": "query",
    "text": "query colorPickerView_palettesListPaginationQuery(\n  $count: Int = 20\n  $cursor: String\n  $paletteTypeID: Int\n) {\n  ...colorPickerView_palettesListFragment_42b45h\n}\n\nfragment colorPickerView_palettesListFragment_42b45h on Query {\n  palettesWithColors(first: $count, after: $cursor, numberOfColorsToShow: 6, paletteTypeID: $paletteTypeID, orderBy: \"DESC\") {\n    edges {\n      node {\n        id\n        name\n        colors {\n          colorID\n          name\n          rgbHexCode\n          spotColorName\n          id\n        }\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "88f0279fe097c549e6876ce8270cbc1b";

export default node;
